import type { VoteWindow } from "@/appInterface/windows/VoteWindow/VoteWindow";
import { canv } from "@/canv/global";
import { getViewport } from "@/canvasController/helpers";
import { getScaledSize } from "@/utils";

const SELECTOR_RADIUS = 16;
const LINE_WIDTH = 1;

export class VoteWindowInterface {
    constructor(voteWindow: VoteWindow) {
        this.voteWindow = voteWindow;
    }

    drawCountVotes({
        startX,
        startY,
        width,
        height,
        widgetUID,
    }: {
        startX: number;
        startY: number;
        width: number;
        height: number;
        widgetUID: string;
    }) {
        this.drawCount({ startX, startY, width, height, widgetUID });
    }

    drawBorder({
        startX,
        startY,
        width,
        height,
    }: {
        startX: number;
        startY: number;
        width: number;
        height: number;
    }) {
        const viewPort = getViewport();
        const ratio = canv.canvas.width / viewPort.viewportWidth;
        const padding = 5 / ratio;
        const lineWidth = getScaledSize(LINE_WIDTH);

        canv.ctx.save();

        canv.ctx.strokeStyle = "#CDCCD7";
        canv.ctx.lineWidth = lineWidth;
        canv.ctx.beginPath();
        canv.ctx.roundRect(
            startX - padding,
            startY - padding,
            width + 2 * padding,
            height + 2 * padding,
            [8 / ratio, 8 / ratio, 8 / ratio, 8 / ratio],
        );

        canv.ctx.stroke();
        canv.ctx.restore();
    }

    drawSelectedBorder({
        startX,
        startY,
        width,
        height,
    }: {
        startX: number;
        startY: number;
        width: number;
        height: number;
    }) {
        const viewPort = getViewport();
        const ratio = canv.canvas.width / viewPort.viewportWidth;
        const padding = 5 / ratio;

        canv.ctx.save();

        canv.ctx.strokeStyle = "#CDCCD7";
        canv.ctx.lineWidth = 1;
        canv.ctx.beginPath();
        canv.ctx.roundRect(
            startX - padding,
            startY - padding,
            width + 2 * padding,
            height + 2 * padding,
            [8 / ratio, 8 / ratio, 8 / ratio, 8 / ratio],
        );

        canv.ctx.stroke();
        canv.ctx.restore();
    }

    drawCount({
        startX,
        startY,
        width,
        height,
        widgetUID,
    }: {
        startX: number;
        startY: number;
        width: number;
        height: number;
        widgetUID: string;
    }) {
        canv.ctx.save();
        const rCanvas = getScaledSize(SELECTOR_RADIUS);
        const centerX = startX + width;
        const centerY = startY + height;

        // фон
        canv.ctx.beginPath();
        canv.ctx.arc(centerX, centerY, rCanvas, 0, 2 * Math.PI);
        canv.ctx.fillStyle = "rgba(13, 153, 255, 1)";
        canv.ctx.fill();

        // число
        const votesCount = this.getWidgetVotes(widgetUID);
        const baseFontSize = (rCanvas * canv.dpr) / 1.5;
        const fontSize = votesCount > 99 ? baseFontSize * 0.7 : baseFontSize;
        this.drawText(votesCount.toString(), centerX, centerY, fontSize, "#ffffff");

        canv.ctx.restore();
    }

    drawText(text: string, x: number, y: number, fontSize: number, color: string) {
        canv.ctx.fillStyle = color;
        canv.ctx.textAlign = "center";
        canv.ctx.textBaseline = "middle";
        canv.ctx.font = `normal ${fontSize}px sans-serif`;
        canv.ctx.fillText(text, x, y);
    }

    getWidgetVotes = (widgetUID: string) => {
        if (!this.voteWindow.voteResult) return 0;
        return this.voteWindow.voteResult.children[widgetUID].votes.length;
    };

    voteWindow: VoteWindow;
}
